/* eslint-disable consistent-return */
/* eslint-disable default-case */
import axios, { AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import enviroment from '../enviroments';
import store from '../store';
import logoff from './logoff';

const createAxiosInstance = () => {
  const config: AxiosRequestConfig = {
    baseURL: enviroment.API_URL_INDENTITY,
    params: {
      cc: '056d1622-4ade-42da-ab38-7126dbca8e0e',
    },
  };

  return axios.create(config);
};

const axiosInstance = createAxiosInstance();

const requesSuccessHandler = (value: any) => {
  const { user } = store.getState();
  if (user.token) {
    value.headers = { Authorization: `Bearer ${user.token}` };
  }
  return value;
};

const requestErrorHandler = (error: any) => error;

const responseSuccessHandler = (response: any) => response;

const responseErrorHandler = (error: any) => {
  if (error && !error.response) {
    if (error.message && error.message.match(/timeout/)) {
      logoff();
      toast.error('⚠  Servidor fora do ar, tente novamente!');
    }
  }
  if (error.response) {
    const { response: { status: code } } = error;
    switch (true) {
      case code >= 500 && code <= 600:
        logoff();
        toast.error('⚠  Servidor fora do ar, tente novamente!');
        break;
      case code === 400:
        break;
      case code === 401:
        break;
      case code === 403:
        break;
      case code === 404:
        break;
      case code === 405:
        break;
    }
    return Promise.reject(error.response);
  }
  return Promise.reject(error.response);
};
axiosInstance.interceptors.request.use(
  requesSuccessHandler,
  requestErrorHandler,
);
axiosInstance.interceptors.response.use(
  responseSuccessHandler,
  responseErrorHandler,
);

export default axiosInstance;
